import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=c85d888a&scoped=true"
import script from "./Deal.vue?vue&type=script&lang=js"
export * from "./Deal.vue?vue&type=script&lang=js"
import style0 from "./Deal.vue?vue&type=style&index=0&id=c85d888a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d888a",
  null
  
)

export default component.exports